import { atom } from 'jotai';

/** Current step index (0-based) */
export const onboardingStepAtom = atom<number>(0);

/** Onboarding record ID (created after step 1 — dealer info) */
export const onboardingRecordIdAtom = atom<string | null>(null);

/** Selected product IDs for multi-select */
export const selectedProductIdsAtom = atom<Set<string>>(new Set<string>());

/** Dev-only: skip auth gate during local development */
export const devSkipAuthAtom = atom<boolean>(false);

/** Dealer info form fields — persisted in Jotai so values survive step navigation */
export const dealerInfoAtom = atom<{
	dealershipName: string;
	websiteUrl: string;
	email: string;
	productType: '' | 'access' | 'dealer';
}>({
	dealershipName: '',
	websiteUrl: '',
	email: '',
	productType: '',
});

/**
 * True when an existing dealer arrived with a pre-selected product via
 * `?product=` query param (e.g. from the frosted lock overlay).
 * Skips the Products step entirely — Payment becomes step 1.
 */
export const hasPreSelectedProductAtom = atom<boolean>(false);

/** Step labels for new dealer flow (Path 1): Dealer Info → Products → Payment → Processing → Setup → Verify Email */
export const NEW_DEALER_STEPS = ['Dealer Info', 'Products', 'Payment', 'Processing', 'Setup', 'Verify Email'] as const;

/** Step labels for existing dealer flow (Path 2): Products → Payment → Processing */
export const EXISTING_DEALER_STEPS = ['Products', 'Payment', 'Processing'] as const;

/** Step labels for existing dealer with pre-selected product: Payment → Processing */
export const PRE_SELECTED_STEPS = ['Payment', 'Processing'] as const;
